import { createFeatureSelector, createSelector } from '@ngrx/store';

import * as fromORings from '../fromORing.barrel';
import { ORing } from 'src/app/models/oring.model';

// feature
const featureState = createFeatureSelector<fromORings.State>('orings');

export const selectHasLoader = (loader: fromORings.Loaders) => createSelector(featureState, state => state.loaders.includes(loader));

// current filter
export const selectActiveFilter = createSelector(featureState, state => state.oringFilter);
export const selectActiveFilterHasValue = createSelector(selectActiveFilter, filt => !!filt.sbuID || !!filt.subSbuID || !!filt.productFamilyID || !!filt.productType || !!filt.pipeSizeID || !!filt.materialID || (filt.sellableCodes || [])?.length > 0);

export const selectORings = createSelector(featureState, (state) => state.orings);
export const selectORingsFiltered = createSelector(selectActiveFilter, featureState, (filter, state) => {
  let result = state.orings;

  if (filter.materialID) 
    result = result.filter(o => o.materialName === filter.materialID);
  if (filter.partNumber) 
    result = result.filter(o => o.partNumber === filter.partNumber);
  if (filter.pipeSizeID) 
    result = result.filter(o => o.sizeList?.split(',').includes(`${filter.pipeSizeID}`));
  if (filter.productFamilyID) 
    result = result.filter(o => o.productFamily === filter.productFamilyID || o.productFamily === null && filter.productFamilyID === 'null');
  if (filter.productType) 
    result = result.filter(o => o.productType === filter.productType);
  if (filter.sbuID && filter.sbuID !== '-1') 
    result = result.filter(o => o.sbu === filter.sbuID || o.sbu === null && filter.sbuID === 'null');
  if (filter.subSbuID && (state.subSBUs.find(s => s.name === filter.subSbuID)?.sbu.name === filter.sbuID || filter.subSbuID === 'null')) 
    result = result.filter(o => o.subSBU === filter.subSbuID || o.subSBU === null && filter.subSbuID === 'null');
  if (filter.sellableCodes) 
    result = result.filter(o => filter.sellableCodes?.includes(o.sellableWH ?? null) || filter.sellableCodes?.includes(o.sellableEH ?? null));
  if (filter.tapRequired === '0')
    result = result.filter(o => o.productFamily !== undefined);
  if (filter.tapRequired === '1')
    result = result.filter(o => o.productFamily === null);
  if (!isNaN(parseInt(filter.minTemp ?? "a"))) 
    result = result.filter(o => (o.minTemp ?? Number.MAX_SAFE_INTEGER) <= parseInt(filter.minTemp ?? "0"));
  if (!isNaN(parseInt(filter.maxTemp ?? "a")))
    result = result.filter(o => (o.maxTemp ?? -Number.MAX_SAFE_INTEGER) >= parseInt(filter.maxTemp ?? "0"));

  return result;
});

export const selectORingsForClosure = createSelector(selectActiveFilter, featureState, (filter, state) => {
  let result = state.orings;

  if (filter.closurePartNumber) result = result.filter(o => o.closureList?.includes(filter.closurePartNumber ?? ''));

  return result;
});

// lookups
export const selectPipeSizes = createSelector(featureState, state => state.pipeSizes);
export const selectMaterials = createSelector(featureState, state => state.materials);
export const selectProductTypes = createSelector(featureState, state => state.productTypes);
export const selectProductFamilies = createSelector(featureState, state => state.productFamilies);
export const selectSBUs = createSelector(featureState, state => state.sbus);
export const selectSubSBUs = createSelector(featureState, state => state.subSBUs);
export const selectSellables = createSelector(featureState, state => state.sellableStatuses);

export const selectFilteredSubSBUs = createSelector(selectActiveFilter, selectSubSBUs, (filt, subsbus) => {
  if (!filt.sbuID || filt.sbuID === '-1') return subsbus;
  return subsbus.filter(s => s.sbu.name === filt.sbuID);
});

// export const selectFilteredProductFamilies = createSelector(selectActiveFilter, selectProductFamilies,
//   (filt, families) => {
//     if (!filt.subSbuID) return families;
//     return families.filter(f => f.productFamily === filt.subSbuID);
//   });

// selected product
const selectedProductPartNumber = createSelector(featureState, state => state.selectedProduct);
export const selectSelectedProduct = createSelector(selectORings, selectedProductPartNumber, (els, pn) => els.find(f => f.partNumber === pn));
export const selectSelectedProductDetail = createSelector(selectSelectedProduct, selectPipeSizes, selectMaterials, selectProductTypes, selectProductFamilies, selectSBUs, selectSubSBUs, selectSellables,
  (product, sizes, materials, equipmentTypes, families, sbus, subsbus, sellables) => {
    // const fam = families.find(f => f.id === parseInt(product?.aX_Data?.productFamilyID ?? '-1'));
    // const sbu = sbus.find(f => f.id === parseInt(product?.aX_Data?.SBUID ?? "-1"));
    // const subsbu = subsbus.find(f => f.SUBSBUID === product?.aX_Data?.SubSBUID);
    // const sellWH = sellables.find(f => f.sellableId === product?.aX_Data?.sellableWHID);
    // const sellEH = sellables.find(f => f.sellableId === product?.aX_Data?.sellableEHID)

    return {
      ...product,
      // materialText: materials.find(m => m.id === product?.materialID)?.text,
      // equipmentTypeText: equipmentTypes.find(e => e.id === product?.equipmentTypeID)?.text,
      // productFamilyText: !!fam ? `${fam?.name} (${fam.id})` : '',
      // sbuText: !!sbu ? `${sbu.name} (${sbu.id})` : '',
      // subSBUText: !!subsbu ? `${subsbu.name} (${subsbu.subSbuID})` : '',
      // sellableWHText: !!sellWH ? `${sellWH.description} (${sellWH.sellableID})` : '',
      // sellableEHText: !!sellEH ? `${sellEH.description} (${sellEH.sellableID})` : ''
    } as ORing;

  });

